module.exports = __webpack_public_path__ + "img/food_list_empty.af52064d.png";